<template>
    <modal
    name="modal-product-management"
    height="auto"
    width="20%"
    class="customSurveyModal"
    :scrollable="true"
    @before-open="beforeOpen"
    @closed="closed">

      <div class="row7">
        <header class="modalHeader flex flexAlignS">
          <div class="title">
            <p>항목추가</p>
          </div>
          <button @click="onClickCancel"></button>
        </header>
      </div>

      <div class="addItemBox">
        <div class="item">
          <input type="text" value="제조구분" disabled>
        </div>
        <div class="item">
          <input type="text" value="제품명" disabled>
        </div>
        <div class="item">
          <input type="text" value="가격" disabled>
        </div>
        <div class="item">
          <input type="text" value="이미지 등록" disabled>
        </div>
        <div class="item">
          <input type="text" value="업체명" disabled>
        </div>
        <div class="item">
          <input type="text" value="제품링크" disabled>
        </div>
        
        <div class="item" v-for="(item, index) in additionalItems" :key="index">
          <input type="text" v-model="additionalItems[index]" :placeholder="'추가사항'+Number(index+1)">
        </div>
      </div>
      
      <div class="modalFooterBtn btnBox">
        <button class="redBtn" @click="onClickSave">등 록</button>
        <button class="redborderBtn" @click="onClickCancel">취 소</button>
      </div>
      
    </modal>
</template>

<script>
import {mapActions} from 'vuex'

export default {
  name: 'ModalProductManagement',
  components: {
  },
  data(){
    return{
      modalResult: false,
      additionalItems: new Array(10)
    }
  },
  computed:{
  },
  mounted(){
    this.show()
  },
  methods:{
    ...mapActions('additionalItem', [
      'requestList',
      'save'
    ]),
    show(){
      this.$modal.show('modal-product-management')
    },
    hide(){
      this.$modal.hide('modal-product-management')
    },
    beforeOpen(){
      this.init()
    },
    closed(){
      this.$emit('modal-closed', this.$options.name, {result: this.modalResult})
    },
    init(){
      this.requestList('PRODUCT')
      .then((response)=>{
        if(response.status === 200){
          const list = response.data
          
          var newItems = new Array(10)
          
          for(var i = 0; i < list.length; i++){
            var index = list[i].ORDER
            newItems[index] = list[i].NAME
          }
          this.additionalItems = newItems
          console.log(this.additionalItems)
        }
        else{
          this.$alert('알림', '데이터를 가져올 수 없습니다.')
        }
      })
      .catch(() =>{
        this.$alert('알림', '데이터 통신을 실패했습니다.')
      })
    },
    onClickSave(){
      this.save({
        type: 'PRODUCT', 
        list: this.additionalItems
      })
      .then((response)=>{
        if(response.status === 200){
          this.$alert('알림', '저장되었습니다.', '확인', {
            'closed': () => {
              this.modalResult = true
              this.hide()  
            }
          })
        }
        else{
          this.$alert('알림', '데이터를 저장할 수 없습니다.')
        }
      })
      .catch(() =>{
        this.$alert('알림', '데이터 통신을 실패했습니다.')
      })
    },
    onClickCancel(){
      this.hide()
    }
  }
}
</script>